import React from 'react';
import { Input, Select, Button, Row, Col, DatePicker } from 'antd';
import SelectPlaceHolder from '../../../components/SelectPlaceHolder';
import moment from 'moment';
const { Option } = Select;
const InputGroup = Input.Group;

class Filters extends React.Component {
    render() {
        return (
            <div className="filfer-container">
                <Row gutter={16}>
                {/* <Col className="gutter-row" sm={24} md={12} lg={4}>
                        <Select
                            showSearch labelInValue
                            value={this.props.filter.idProducto ? { key: this.props.filter.idProducto } : undefined}
                            placeholder={<SelectPlaceHolder label="Filtrar por producto" />}
                            onChange={(option) => this.props.onChange("idProducto", option.key)} //STATE PROPERTY
                            optionFilterProp="children"
                            loading={this.props.productosLoading}
                        >
                            <Option key={'0'} value={'0'}>
                                <span>TODOS</span>
                            </Option>
                            {this.props.productos.map(item => (
                                <Select.Option value={item.id} key={item.id}>{item.nombre}</Select.Option>
                            ))}
                        </Select>
                    </Col> */}

                    <Col className="gutter-row" sm={24} md={12} lg={4}>
                        <InputGroup compact>
                            <Select showSearch labelInValue
                                value={this.props.filter.idProducto ? { key: this.props.filter.idProducto } : undefined}
                                style={{ width: `calc(100% - 40px)` }}
                                placeholder={"Búsqueda de Productos"}
                                optionFilterProp="children"
                                showArrow={false}
                                onSearch={this.props.onSearchAutocomplete}
                                onChange={this.props.onChangeAutocomplete}
                            >
                                {this.props.productos.map(item => (
                                    <Option key={item.id} value={item.id}>{item.nombre}</Option>
                                ))}
                            </Select>
                            <Button
                                className="btn-autocomplete"
                                style={{ width: '40px', fontSize: '14px' }}
                                icon={this.props.filter.idProducto ? 'close' : 'search'}
                                onClick={this.props.onClearAutocomplete}
                            />
                        </InputGroup>
                    </Col>
                <Col className="gutter-row" sm={24} md={12} lg={4}>
                        <Select
                            showSearch labelInValue
                            value={this.props.filter.idTipoReporteInventario ? { key: this.props.filter.idTipoReporteInventario } : undefined}
                            placeholder={<SelectPlaceHolder label="Filtrar por establecimiento" />}
                            onChange={(option) => this.props.onChange("idTipoReporteInventario", option.key)} //STATE PROPERTY
                            optionFilterProp="children"
                        >
                            {this.props.tiposReporteInventario.map(item => (
                                <Select.Option value={item.id} key={item.id}>{item.nombre}</Select.Option>
                            ))}
                        </Select>
                    </Col>
                    <Col className="gutter-row" sm={24} md={12} lg={4}>
                        <Select
                            showSearch labelInValue
                            value={this.props.filter.idEstablecimiento ? { key: this.props.filter.idEstablecimiento } : undefined}
                            placeholder={<SelectPlaceHolder label="Filtrar por establecimiento" />}
                            onChange={(option) => this.props.onChange("idEstablecimiento", option.key)} //STATE PROPERTY
                            optionFilterProp="children"
                            loading={this.props.establecimientosLoading}
                        >
                            <Option key={'0'} value={'0'}>
                                <span>TODOS</span>
                            </Option>
                            {this.props.establecimientos.map(item => (
                                <Select.Option value={item.id} key={item.id}>{item.nombre}</Select.Option>
                            ))}
                        </Select>
                    </Col>
                    <Col className="gutter-row" sm={24} md={12} lg={4}>
                        <Select
                            showSearch labelInValue
                            value={this.props.filter.idAlmacen ? { key: this.props.filter.idAlmacen } : undefined}
                            placeholder={<SelectPlaceHolder label="Filtrar por almacén" />}
                            onChange={(option) => this.props.onChange("idAlmacen", option.key)}
                            optionFilterProp="children"
                            loading={this.props.monedasLoading}
                        >
                            <Option key={'0'} value={'0'}>
                                <span>TODOS</span>
                            </Option>
                            {this.props.almacenes.map(item => (
                                <Select.Option value={item.id} key={item.id}>{item.nombre}</Select.Option>
                            ))}
                        </Select>
                    </Col>
                    <Col className="gutter-row" sm={24} md={12} lg={4}>
                        <Select
                            showSearch labelInValue
                            value={this.props.filter.idMoneda ? { key: this.props.filter.idMoneda } : undefined}
                            onChange={(option) => this.props.onChange("idMoneda", option.key)}
                            optionFilterProp="children"
                            loading={this.props.establecimientosLoading}
                        >
                            {this.props.monedas.map(item => (
                                <Select.Option value={item.id} key={item.id}>{item.nombre}</Select.Option>
                            ))}
                        </Select>
                    </Col>
                    <Col className="gutter-row" sm={24} md={12} lg={4}>
                        <DatePicker
                            placeholder="Filtrar por fecha fin"
                            format="DD/MM/YYYY"
                            value={this.props.filter.fechaHastaFormat === '' ? null : moment(this.props.filter.fechaHastaFormat, 'DD/MM/YYYY')}
                            onChange={(_, value) => this.props.onChange('fechaHastaFormat', value)}
                        />
                    </Col>
                </Row>
            </div>
        );
    }
}

export default Filters;